import React from 'react';
import useTheme from 'branding/theme';
import useSectionMargin from '../../hooks/useSectionMargin';
const ListBorders = ({ children, noOuterBorder = false, hasErrors = false, margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginLeft, marginRight, className, styles }) => {
    const childrenArray = React.Children.toArray(children);
    const { borders: { base, shape, bottom, variant, error } } = useTheme();
    const marginStyles = useSectionMargin({
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight
    });
    const borderColorStyles = hasErrors ? error : variant.secondary;
    const outerBorderStyles = {
        ...base,
        ...shape.rounded,
        ...borderColorStyles
    };
    const wrapperStyles = {
        ...(!noOuterBorder && outerBorderStyles),
        ...marginStyles,
        ...(hasErrors && { marginBottom: 0 }),
        ...styles
    };
    const itemStyles = {
        ...bottom,
        ...borderColorStyles
    };
    return (React.createElement("div", { className: className, style: wrapperStyles }, childrenArray.map((child, i) => (React.createElement("div", { key: i, style: childrenArray.length - 1 > i ? itemStyles : undefined }, child)))));
};
export default ListBorders;
//# sourceMappingURL=index.js.map